<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <VcConfirmModal show-dialog
                      :title="$t('client.matters.matter_page.docuforms_tab.view_signature')"
                      size="sm"
                      @onCloseButtonClicked="handleClose">

        <template slot="content">
          <div class="signature-description"
               v-html="$t('document.view_signature.description', {name: dialogProps.contactName})"/>

          <div class="signature-container">
            <VcLoader v-if="!signature"/>

            <template v-else>
              <img :src="signature.image_url || signature.image"/>
              <div class="signature-container__line"/>
              <div class="signature-container__timestamp">{{signature.created_at | date_and_hour}}</div>
            </template>
          </div>
        </template>

        <template slot="footer">
          <VcButton :label="$t('common.dialog.close')"
                    color="white"
                    @click="handleClose"/>
        </template>

      </VcConfirmModal>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import {signaturesService} from "@/modules/common/services";

export default {
  name: "ViewSignatureDialog",
  components: {FullscreenFrontageDialog},
  props: {
    entityType: {
      type: String,
      required: true
    },
    entityUid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      signature: null
    }
  },
  async created() {
    this.signature = await signaturesService.getSignature(this.entityType, this.entityUid);
  },
  methods: {
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.signature-description {
  margin-bottom: 10px;
}

.signature-container {
  height: 225px;
  width: 100%;
  border: 1px solid $dividerColor;
  border-radius: 4px;
  padding: 3px;
  overflow: hidden;

  .v-progress-circular {
    width: 100% !important;
    top: 50%;
    transform: translateY(-50%);
  }

  &__line {
    position: relative;
    bottom: 60px;
    margin: 0 25px;
    border: 1px solid $grey-color-5;
  }

  &__timestamp {
    position: relative;
    bottom: 50px;
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: $grey-color-5;
  }

  img {
    height: 100%;
  }
}
</style>
